'use client';

import dynamic from 'next/dynamic';
import PageHeader from '../../../components/common/PageHeader';

const RegularTour = dynamic(() => import('../../../components/RegularTour'), {
  ssr: false,
});

const getParams = (slug: string | string[]) => {
  // renderType
  // 0 : /tour/:slug
  // 1 : /token/:token
  // 2 : /tour/:slug/:videoType/:rule/:agentId/:chatToken
  // 2 : /tour/:slug/:videoType/:rule/:chatToken
  let matterId;
  let videoType;
  let rule;
  let agentId;
  let room;
  let renderType = 2;

  if (
    slug?.length === 1 ||
    (slug.length > 1 && slug[1] === 'processOrder') ||
    (slug.length > 1 && slug[1] === 'book') ||
    (slug.length > 1 && slug[1] === 'login')
  ) {
    matterId = slug[0];
    renderType = 0;
  } else if (slug?.length === 4) {
    matterId = slug[0];
    videoType = slug[1];
    rule = slug[2];
    room = slug[3];
  } else if (slug?.length === 5) {
    matterId = slug[0];
    videoType = slug[1];
    rule = slug[2];
    agentId = slug[3];
    room = slug[4];
  }
  const params = {
    matterId,
    videoType,
    rule,
    agentId,
    room,
    renderType,
  };

  return params;
};

type Props = {
  data: string;
  slug: string[];
};

export default function TourPageClient({ data, slug }: Props) {
  const parsedData = JSON.parse(data);

  const {
    title,
    description,
    tourImage,
    website,
    fbPixel,
    fbAppId,
    faviconUrl,
    htmlCode,
    tourData,
    tags,
    matterTags,
    charset,
    error,
  } = parsedData;

  const { matterId, renderType, videoType, rule, agentId, room } = getParams(slug);

  return (
    <PageHeader
      title={title}
      description={description}
      slug={matterId}
      tourImage={tourImage}
      website={website}
      fbPixel={fbPixel}
      fbAppId={fbAppId}
      faviconUrl={faviconUrl}
      htmlCode={htmlCode}
      type="tour"
      charset={charset}
    >
      <RegularTour
        tourData={tourData}
        tags={tags}
        matterTags={matterTags}
        tourImage={tourImage}
        renderType={renderType}
        matterId={matterId}
        videoType={videoType}
        agentId={agentId || null}
        rule={rule}
        room={room}
        reactAws={process.env.NEXT_PUBLIC_CDN}
        reactAppDomain={process.env.NEXT_PUBLIC_API}
        reactAppMatterPort={process.env.NEXT_PUBLIC_MP_SDK_KEY}
        reactPaypalClient={process.env.NEXT_PUBLIC_PAYPAL_CLIENT}
      />
    </PageHeader>
  );
}
